import { Validators } from '@angular/forms';

export class ProductModel {
  type = {
    value: null,
    validation: Validators.compose([])
  };
  primaryPurpose = {
    value: null,
    validation: Validators.compose([])
  };
  purposeGroupType = {
    value: null,
    validation: Validators.compose([])
  };
  oid = {
    value: null,
    validation: Validators.compose([])
  };
  occupancyType = {
    value: null,
    validation: Validators.compose([])
  };
  interestType = {
    value: null,
    validation: Validators.compose([])
  };
  repaymentType = {
    value: null,
    validation: Validators.compose([])
  };
  loanAmount = {
    value: null,
    validation: Validators.compose([])
  };
  lvr = {
    value: null,
    validation: Validators.compose([])
  };
  output = {
    value: [],
    validation: Validators.compose([])
  };
  bridging = {
    value: false,
    validation: Validators.compose([])
  };
  imported = {
    value: false,
    validation: Validators.compose([])
  };
}
